import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import { Typography, Box } from "@mui/material";
import Closed from '../../assets/img/closed.png';

export default function PopupUnlockGiveaway(props) {

    return (
        <div>
            <Box
                sx={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)', // โปร่งใส
                    zIndex: 10,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
            
                <img src={Closed} height="160px" />
                <Typography style={{ color: "#EF193B", fontWeight: "bold", fontSize: 48 }} >
                    {props.line} ยังไม่เปิดใช้งาน
                </Typography>
                <Typography style={{ color: "#EF193B", fontWeight: "bold", fontSize: 48 }} >
                    "Giveaway Level 4"
                </Typography>
            </Box>
        </div>
    );
}